import React, { forwardRef } from 'react'
import styled from 'styled-components'

interface Props extends React.ComponentProps<'button'> {}

const PlainButton = forwardRef<HTMLButtonElement, Props>(
  ({
    ...props
  }, ref) => {
    return (
      <CustomButton
        {...props}
        ref={ref}
      />
    )
  }
)

export default PlainButton

const CustomButton = styled.button`
  outline: none;
  border: none;
  color: inherit;
  font: inherit;
  background-color: unset;
`
